module.exports = [{
      plugin: require('/home/ec2-user/api/wtl-project-starter/build.c9fb5ff2-95d1-411d-90b7-0fe84cf3c482/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
